import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
} from "reactstrap";
import { Button } from "ui-kit-takeat";

function BrandDeleteModal({ isOpen, toggle, brand, onConfirm, deleting }) {
  if (!brand) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Excluir Marca</ModalHeader>
      <ModalBody>
        <Container>
          Deseja realmente excluir a marca{" "}
          <b>{brand.fantasy_name}</b>?
          <p style={{ marginTop: 8, color: "#6c6c6c" }}>
            Essa ação não pode ser desfeita.
          </p>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          title="Cancelar"
          buttonColor="#6c757d"
          onClick={toggle}
          containerStyles={{ height: 36 }}
        />
        <Button
          title={deleting ? "Excluindo..." : "Confirmar"}
          buttonColor="#C8131B"
          onClick={onConfirm}
          disabled={deleting}
          containerStyles={{ height: 36 }}
        />
      </ModalFooter>
    </Modal>
  );
}

export default BrandDeleteModal;
